import * as api from "@/api/williams/contractors";
import { Contractor } from "@/api/williams/contractors";
import { UseFormReturn } from "react-hook-form";

export function useContractorValidation(form: UseFormReturn<Contractor>) {
  return async function validate(contractor: Contractor) {
    const result = await api.validateContractor(contractor);

    if (!result.isContractorUnique) {
      form.setError("root", { message: "Contractor already exists" });
    }

    return result.isContractorUnique;
  };
}
